<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Travel Payments That Scale</div>
            <div class="banner_tips mt-40 fw-300">Modern payment infrastructure for travel businesses. Built for simplicity, speed, and scale. Customers and growth first.</div>
             <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
          </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name  ">Why Choose CorelinkPay for Travel Payments?</div> 
            </div>
            <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12" v-for="tab in tabList" :key="tab.id" >
                    <div class="tab_left text-l border-card p-20 h-100p card_bg">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img :src="tab.icon" alt="" class="">
                        </div>
                        <div class="half_title ">{{ tab.title }}</div>
                        <div class="half_text  mt-10 fs-14 fw-300">{{ tab.msg }}</div>
                    </div>
                </div>
              </div>
          </div>  
        </div>
      </div>
    </div>

    <div class="container page_title_bg py-80">
        <div class="page_width">
            <div class="page_title ">
                <div class="title_name color1 ">FAQs</div>
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="What is open banking?" name="1">
                            <div class="coll_item">Open banking allows traditional banks to share data securely with licensed fintech providers like CorelinkPay, enabling faster, more efficient transactions for your business.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="How fast are transactions processed?" name="2">
                           <div class="coll_item">With CorelinkPay, payments are processed instantly, and funds appear in your account within minutes.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can CorelinkPay support my growing business?" name="3">
                           <div class="coll_item">Absolutely. Our scalable plans are designed to adapt to your business needs, from small startups to large enterprises.</div>
                          </el-collapse-item>
                       
                        </el-collapse>
                      </div>
                </div>
               

            </div>
        </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t51.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name  text-l">Transform Your Travel Business Today</div>
                        <div class="title_tag  text-l">With CorelinkPay, you get more than a payment platform—you get a partner dedicated to your success. Connect with us to streamline your payments and fuel your growth.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>


   
  </div>
</template>

<script>
import tab1 from '../../assets/image/tb32.png'
import tab2 from '../../assets/image/tb33.png'
import tab3 from '../../assets/image/tb34.png'
import tab4 from '../../assets/image/tb35.png'
import tab5 from '../../assets/image/tb36.png'


export default {
    data(){
        return{
          
          
            activeName:'1',
            tabList:[
                {title:"Flexible, Scalable Solutions",msg:"Plans that grow with you. From startups to established agencies, tools to scale seamlessly.",id:1,icon:tab1},
                {title:"Instant Transactions",msg:"Lightning-fast payments. Funds transferred and reflected in minutes for smooth, efficient operations.",id:2,icon:tab2},
                {title:"AI-Powered Insights",msg:"Advanced AI and machine learning for actionable analytics, optimized transaction flows, and better customer experiences.",id:3,icon:tab3},
                {title:"Open Banking Excellence",msg:"Seamless connections with major banks across the UK and EU. Secure, streamlined transactions through open banking.",id:4,icon:tab4},
                {title:"User-Friendly APIs",msg:"Intuitive APIs to bring travel products to market quickly with minimal technical hassle.",id:5,icon:tab5},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg8.png);
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}


</style>